// extracted by mini-css-extract-plugin
module.exports = {"manual":"Manual_manual__2Du_d","text":"Manual_text__2AXYr","titlebold":"Manual_titlebold__1zMMd","titleapp":"Manual_titleapp__1LBra"};